import { configureStore, createSlice } from "@reduxjs/toolkit";

const postPageSlice = createSlice({
  name: "counter",
  initialState: {
    communityMembersPics: {},
    flatlistVisibleElement:{}
  },
  reducers: {
    setCommunityMembersPics(state, action) {
      state.communityMembersPics[action.payload["communityId"]] =
        action.payload["pics"];
    },
    updateFlatlistVisibleElement(state, action) {
      state.flatlistVisibleElement[action.payload?.class][action.payload?.pageKey] =
        action.payload?.item;
    },
  },
});

export const actions = postPageSlice.actions;

const store = configureStore({
  reducer: postPageSlice.reducer,
});
export default store;
